import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useGetSSNRequiredStatesConfiguration() {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_SSN_REQUIRED_STATES, {
    defaultValue: {
      enabled: false,
      states: [],
    },
  });
}
